import { useState } from 'react';
import DocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import "@cyntler/react-doc-viewer/dist/index.css";

export default function PptxViewer({ apiUrl, templateId, onClose, initialPptxUrl }) {
  const [pptxUrl, setPptxUrl] = useState(initialPptxUrl || null);
  const [isGenerating, setIsGenerating] = useState(false);
  const [error, setError] = useState(null);

  const handleGenerate = async () => {
    setIsGenerating(true);
    setError(null);
    try {
      const response = await fetch(`${apiUrl}/board/templates/${encodeURIComponent(templateId)}/generate-pptx`, {
        method: 'POST',
      });
      if (!response.ok) {
        const text = await response.text();
        throw new Error(text || `HTTP ${response.status}`);
      }
      const data = await response.json();
      if (data.pptx_url) {
        const fullUrl = data.pptx_url.startsWith('http')
          ? data.pptx_url
          : `${apiUrl}${data.pptx_url}`;
        setPptxUrl(fullUrl);
      } else {
        throw new Error('No PPTX URL returned');
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setIsGenerating(false);
    }
  };

  const docs = pptxUrl ? [{ uri: pptxUrl, fileType: 'pptx' }] : [];

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div
        className="modal-content pptx-viewer-modal"
        onClick={(e) => e.stopPropagation()}
        style={{
          width: '90vw',
          maxWidth: '1100px',
          height: '85vh',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <div className="modal-header">
          <h2>Presentation Viewer</h2>
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            {pptxUrl && (
              <a
                href={pptxUrl}
                download
                className="modal-button"
                style={{ textDecoration: 'none', fontSize: '0.85rem' }}
              >
                Download PPTX
              </a>
            )}
            <button className="modal-close" onClick={onClose}>
              &times;
            </button>
          </div>
        </div>
        <div style={{ flex: 1, overflow: 'auto', padding: '16px' }}>
          {!pptxUrl && !isGenerating && !error && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: '16px',
              color: 'var(--muted, #888)',
            }}>
              <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" aria-hidden="true">
                <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
                <polyline points="14 2 14 8 20 8" />
                <line x1="16" y1="13" x2="8" y2="13" />
                <line x1="16" y1="17" x2="8" y2="17" />
                <polyline points="10 9 9 9 8 9" />
              </svg>
              <p style={{ fontSize: '1.1rem', fontWeight: 600 }}>Generate a PowerPoint presentation</p>
              <p style={{ fontSize: '0.9rem' }}>Convert the current app into a downloadable PPTX file</p>
              <button
                className="modal-button primary"
                onClick={handleGenerate}
                style={{ marginTop: '8px' }}
              >
                Generate PPTX
              </button>
            </div>
          )}

          {isGenerating && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: '12px',
            }}>
              <div className="gallery-loading-spinner" />
              <p style={{ color: 'var(--muted, #888)' }}>Generating presentation...</p>
            </div>
          )}

          {error && (
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              justifyContent: 'center',
              height: '100%',
              gap: '12px',
              color: 'var(--error, #e74c3c)',
            }}>
              <p style={{ fontWeight: 600 }}>Error generating PPTX</p>
              <p style={{ fontSize: '0.9rem' }}>{error}</p>
              <button
                className="modal-button primary"
                onClick={handleGenerate}
                style={{ marginTop: '8px' }}
              >
                Retry
              </button>
            </div>
          )}

          {pptxUrl && (
            <DocViewer
              documents={docs}
              pluginRenderers={DocViewerRenderers}
              style={{ height: '100%' }}
              config={{
                header: {
                  disableHeader: true,
                  disableFileName: true,
                },
              }}
            />
          )}
        </div>
      </div>
    </div>
  );
}
